module.exports = __webpack_public_path__ + "img/icon_next_bottom.7ef62dd7.svg";